import { withHydrate } from '@relay/react/hooks';
import Link from '@stories/Elements/Forms/Buttons/Link';
import ImageTransform from '@tti/image-transform';
import React from 'react';
import { WhatsNewBannerStyles as s } from './WhatsNewBanner.styles';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const WhatsNewBanner = ({
  mainHeading,
  subHeading,
  supportingText,
  footerLeftImage,
  footerLogoImage,
  footerTextContent,
  buttonText,
  buttonUrl,
  desktopImage,
  mobileImage
}) => {
  return /*#__PURE__*/_jsxs(s.Wrapper, {
    children: [/*#__PURE__*/_jsxs(s.Container, {
      desktopImage: desktopImage ? desktopImage : '',
      mobileImage: mobileImage ? mobileImage : '',
      children: [/*#__PURE__*/_jsxs(s.ContentContainer, {
        children: [mainHeading && /*#__PURE__*/_jsx(s.Title, {
          dangerouslySetInnerHTML: {
            __html: mainHeading
          }
        }), subHeading && /*#__PURE__*/_jsx(s.Subtitle, {
          dangerouslySetInnerHTML: {
            __html: subHeading
          }
        }), supportingText && /*#__PURE__*/_jsx(s.SupportingText, {
          dangerouslySetInnerHTML: {
            __html: supportingText
          }
        })]
      }), footerLogoImage && /*#__PURE__*/_jsx(s.FooterLogoContainer, {
        children: /*#__PURE__*/_jsx(s.FooterLogo, {
          src: new ImageTransform(footerLogoImage).width(150).url
        })
      })]
    }), /*#__PURE__*/_jsxs(s.Footer, {
      children: [/*#__PURE__*/_jsx(s.FooterBlock, {
        children: footerLeftImage && /*#__PURE__*/_jsx(s.FooterImage, {
          src: new ImageTransform(footerLeftImage).width(250).url
        })
      }), /*#__PURE__*/_jsx(s.FooterBlock, {
        children: footerTextContent && /*#__PURE__*/_jsx(s.FooterContent, {
          children: footerTextContent
        })
      }), /*#__PURE__*/_jsx(s.FooterButtonBlock, {
        children: buttonText && buttonUrl && /*#__PURE__*/_jsx(Link, {
          text: buttonText,
          href: buttonUrl,
          theme: "white-outline",
          icon: "arrow",
          size: "small"
        })
      })]
    })]
  });
};
export default withHydrate(WhatsNewBanner, 'WhatsNewBanner', 'hybrid');
